import t from "./ghl-ui.es760.js";
import m from "./ghl-ui.es745.js";
var r = "[object Symbol]";
function i(o) {
  return typeof o == "symbol" || m(o) && t(o) == r;
}
export {
  i as default
};
